<template>
  <div class="miniusers-page">
    <!-- SearchBar -->
    <div class="search-section">
      <div class="search-container">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input
              placeholder="Search User ID"
              v-model="search.user_id"
              @clear="handleSearch()"
              @keyup.enter.native="handleSearch()"
              clearable
              size="medium">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Search Phone"
              v-model="search.phone"
              @clear="handleSearch()"
              @keyup.enter.native="handleSearch()"
              clearable
              size="medium">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Search Nickname"
              v-model="search.nickname"
              @clear="handleSearch()"
              @keyup.enter.native="handleSearch()"
              clearable
              size="medium">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="search.is_vip"
              placeholder="VIP Status"
              @change="handleSearch()"
              clearable
              size="medium">
              <el-option label="Normal" :value="0" />
              <el-option label="VIP" :value="1" />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <el-table
        :data="users"
        border
        stripe
        :header-cell-class-name="'headerBg'"
        class="custom-table"
        style="width: 100%"
      >
        <el-table-column type="index" label="#" width="40" align="center" />
        <el-table-column prop="user_id" label="User ID" width="120" align="center" />
        <el-table-column prop="phone" label="手机号" width="120" align="center" />
        <el-table-column prop="nickname" label="昵称" align="center" />
        <el-table-column prop="gendervalue" label="性别称呼" align="center" />
        <el-table-column label="VIP状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_vip ? 'warning' : 'info'">
              {{ scope.row.is_vip ? 'VIP' : '普通' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="收藏" width="90" align="center">
          <template slot-scope="scope">
            <el-button 
              type="text" 
              size="small" 
              @click="goToFavorites(scope.row)"
              :disabled="!scope.row.favorite_count || scope.row.favorite_count === 0">
              共 {{ scope.row.favorite_count || 0 }} 个
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="last_login_at" label="最近登录" width="140" align="center" />
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="small" @click="goDetail(scope.row)">
                <i class="el-icon-view" /> 详情
              </el-button>
              <el-button
                v-if="!scope.row.is_vip"
                type="warning"
                size="small"
                @click="openActivateVip(scope.row)"
              >
                <i class="el-icon-medal" /> 开通VIP
              </el-button>
              <el-button
                v-else
                type="danger"
                size="small"
                @click="handleDeactivateVip(scope.row)"
                :loading="deactivating === scope.row.user_id"
              >
                <i class="el-icon-remove-outline" /> 关闭VIP
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          :layout="'total, sizes, prev, pager, next, jumper'"
          :total="total"
        />
      </div>
    </div>

    <!-- Activate VIP Dialog -->
    <el-dialog
      title="开通VIP会员"
      :visible.sync="activateVipVisible"
      :width="'30%'"
      class="custom-dialog"
      :close-on-click-modal="false"
    >
      <el-form label-width="80px" size="small" class="edit-form" v-if="activateForm.user_id">
        <el-form-item label="会员类型" required>
          <el-select
            v-model="activateForm.vip_type_id"
            placeholder="请选择会员类型"
            filterable
            style="width: 100%"
            @change="onVipTypeChange">
            <el-option
              v-for="type in vipTypes"
              :key="type.id"
              :label="type.name_zh"
              :value="type.id">
              <span>{{ type.name_zh }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px" v-if="type.amount !== null && type.amount !== undefined">
                ¥{{ Number(type.amount).toFixed(2) }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会费金额">
          <el-input-number
            v-model="activateForm.amount"
            :min="0"
            :step="0.1"
            :precision="2"
            :controls="false"
            placeholder="不填则使用会员类型默认金额"
            style="width: 100%"
          />
          <div class="field-tip" v-if="selectedVipType && selectedVipType.amount">
            <i class="el-icon-info"></i> 默认金额：¥{{ Number(selectedVipType.amount).toFixed(2) }}
          </div>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="activateForm.start_date"
            type="datetime"
            placeholder="不填则默认为今天"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="activateForm.end_date"
            type="datetime"
            placeholder="不填则为永久会员"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="activateForm.notes"
            type="textarea"
            :rows="3"
            placeholder="备注"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="activateVipVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitActivateVip" :loading="activating">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/timeUtil'

export default {
  name: 'MiniUsers',
  data() {
    return {
      users: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      vipTypes: [],
      search: {
        user_id: '',
        phone: '',
        nickname: '',
        is_vip: null
      },
      activateVipVisible: false,
      activating: false,
      deactivating: null,
      activateForm: {
        user_id: null,
        vip_type_id: null,
        amount: null,
        start_date: '',
        end_date: '',
        notes: ''
      }
    }
  },
  computed: {
    selectedVipType () {
      if (!this.activateForm.vip_type_id) return null
      return this.vipTypes.find(t => t.id === this.activateForm.vip_type_id)
    }
  },
  created() {
    const initVip = this.$route.query.is_vip
    if (initVip === '0' || initVip === '1') {
      this.search.is_vip = Number(initVip)
    }
    this.getVipTypes()
    this.getUsers()
  },
  methods: {
    handleSearch() {
      this.pageNum = 1
      this.getUsers()
    },
    resetSearch() {
      this.search.user_id = ''
      this.search.phone = ''
      this.search.nickname = ''
      this.search.is_vip = null
      this.pageNum = 1
      this.getUsers()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.getUsers()
    },
    handleCurrentChange(page) {
      this.pageNum = page
      this.getUsers()
    },
    getUsers() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.search.user_id) params.user_id = this.search.user_id
      if (this.search.phone) params.phone = this.search.phone
      if (this.search.nickname) params.nickname = this.search.nickname
      if (this.search.is_vip !== null && this.search.is_vip !== undefined) {
        params.is_vip = this.search.is_vip
      }
      this.request
        .get('/namzar/admin/miniUsers', { params })
        .then(res => {
          const list = Array.isArray(res?.data) ? res.data : []
          this.total = res.total || list.length
          this.users = list.map(item => ({
            id: item.id,
            user_id: item.user_id,
            openid: item.openid,
            phone: item.phone,
            nickname: item.nickname,
            gendervalue: item.gendervalue,
            is_vip: item.is_vip,
            favorite_count: item.favorite_count || 0,
            last_login_ip: item.last_login_ip,
            last_login_user_agent: item.last_login_user_agent,
            last_login_at: item.last_login_at ? formatDateTime(item.last_login_at) : '',
            updated_at: item.updated_at ? formatDateTime(item.updated_at) : ''
          }))
        })
        .catch(res => {
          this.$message.error(res?.message || '获取数据失败')
        })
    },
    goDetail(row) {
      this.$router.push(`/admin/mini-users/${row.id}`)
    },
    goToFavorites(row) {
      this.$router.push(`/admin/mini-users/${row.id}/favorites`)
    },
    getVipTypes() {
      this.request
        .get('/namzar/admin/vipType')
        .then(res => {
          const data = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []
          this.vipTypes = data.map(item => ({
            id: item.id,
            name_zh: item.name_zh,
            name_ug: item.name_ug,
            amount: item.amount
          }))
        })
    },
    openActivateVip(row) {
      this.activateForm = {
        user_id: row.user_id,
        vip_type_id: null,
        amount: null,
        start_date: '',
        end_date: '',
        notes: ''
      }
      this.activateVipVisible = true
    },
    onVipTypeChange(vipTypeId) {
      if (vipTypeId) {
        const selectedType = this.vipTypes.find(t => t.id === vipTypeId)
        if (!selectedType) return
        // 自动带入会员类型的默认设置，用户仍可修改
        if (selectedType.amount !== null && selectedType.amount !== undefined) {
          this.activateForm.amount = selectedType.amount
        }
      }
    },
    submitActivateVip() {
      if (!this.activateForm.user_id) {
        this.$message.warning('缺少用户ID')
        return
      }
      if (!this.activateForm.vip_type_id) {
        this.$message.warning('请选择会员类型')
        return
      }

      const payload = {
        user_id: this.activateForm.user_id,
        vip_type_id: this.activateForm.vip_type_id
      }
      
      // 可选字段
      if (this.activateForm.amount !== null && this.activateForm.amount !== undefined && this.activateForm.amount > 0) {
        payload.amount = this.activateForm.amount
      }
      if (this.activateForm.start_date) {
        payload.start_date = this.activateForm.start_date
      }
      if (this.activateForm.end_date) {
        payload.end_date = this.activateForm.end_date
      }
      if (this.activateForm.notes) {
        payload.notes = this.activateForm.notes
      }

      this.activating = true
      this.request
        .post('/namzar/admin/memberships/activate', payload)
        .then(res => {
          if (res && (res.code === 200 || res.message)) {
            this.$message.success(res.message || '开通VIP成功')
            this.activateVipVisible = false
            this.getUsers() // 刷新列表
          } else {
            this.$message.error(res.message || '开通VIP失败')
          }
        })
        .catch(res => {
          this.$message.error(res?.message || '开通VIP失败')
        })
        .finally(() => {
          this.activating = false
        })
    },
    handleDeactivateVip(row) {
      this.$confirm('确定要关闭该用户的VIP会员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deactivateVip(row)
      }).catch(() => {})
    },
    deactivateVip(row) {
      this.deactivating = row.user_id
      this.request
        .post('/namzar/admin/memberships/deactivate', {
          user_id: row.user_id
        })
        .then(res => {
          if (res && res.code === 200) {
            const affectedRows = res.data?.affected_rows || 0
            this.$message.success(`会员记录已失效，已关闭 ${affectedRows} 条会员记录`)
            this.getUsers() // 刷新列表
          } else {
            this.$message.error(res?.message || '关闭VIP失败')
          }
        })
        .catch(res => {
          this.$message.error(res?.message || '关闭VIP失败')
        })
        .finally(() => {
          this.deactivating = null
        })
    }
  }
}
</script>

<style scoped>
.miniusers-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
}

.search-section {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.table-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow-x: auto;
}

.custom-table {
  border-radius: 8px;
  overflow: hidden;
  min-width: 900px;
}

.custom-table ::v-deep .el-table__header-wrapper {
  background-color: #f5f7fa;
}

.custom-table ::v-deep .el-table__header th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.pagination-wrapper {
  margin-top: 16px;
  text-align: center;
}

.pagination-wrapper ::v-deep .el-pagination {
  justify-content: center;
}

.custom-table ::v-deep .el-table__row:hover {
  background-color: #f5f7fa;
}

.headerBg {
  background: #eee !important;
}

.edit-form ::v-deep .el-form-item {
  margin-bottom: 14px;
}

.mobile-footer {
  padding: 12px 15px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.field-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.field-tip i {
  font-size: 14px;
}
</style>


